type IconName =
  | "gear"
  | "coin"
  | "heart"
  | "clock"
  | "magnet"
  | "brush"
  | "hourglass"
  | "home"
  | "restart"
  | "pause"
  | "sound";

const PATHS: Readonly<Record<IconName, string>> = {
  gear: '<path d="M10 2h4l.7 3.1 2.2 1.3 3-1 2 3.5-2.3 2.2v2.6l2.3 2.2-2 3.5-3-1-2.2 1.3L14 22h-4l-.7-3.2-2.2-1.3-3 1-2-3.5 2.3-2.2v-2.6L2.1 8l2-3.5 3 1 2.2-1.3L10 2zm2 6a4 4 0 100 8 4 4 0 000-8z"/>',
  coin: '<circle cx="12" cy="12" r="8.5"/><path d="M12 6.5l1.55 3.15 3.48.5-2.52 2.46.6 3.46L12 14.43l-3.11 1.64.6-3.46-2.52-2.46 3.48-.5L12 6.5z" fill="white"/>',
  heart: '<path d="M12 20.2S4 15.25 4 9.1C4 5.3 8.6 3.7 12 7c3.4-3.3 8-1.7 8 2.1 0 6.15-8 11.1-8 11.1z"/>',
  clock: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7v5l3.5 2" fill="none" stroke="white" stroke-width="2.2" stroke-linecap="round"/>',
  magnet: '<path d="M5 5h5v7a2 2 0 004 0V5h5v7a7 7 0 01-14 0V5z"/><path d="M5 8h5M14 8h5" stroke="white" stroke-width="2"/>',
  brush: '<path d="M8 4h8l-1 9H9L8 4z"/><path d="M9 13h6l2 4c.7 1.5-.3 3-2 3H9c-1.7 0-2.7-1.5-2-3l2-4z" fill="white"/>',
  hourglass: '<path d="M7 3h10v3c0 2.5-1.7 4.2-3.3 6 1.6 1.8 3.3 3.5 3.3 6v3H7v-3c0-2.5 1.7-4.2 3.3-6C8.7 10.2 7 8.5 7 6V3z"/>',
  home: '<path d="M3.5 11.3L12 4l8.5 7.3v8.2h-6V14h-5v5.5h-6v-8.2z"/>',
  restart: '<path d="M18.7 7.1V3.7l-2.1 2.1A8 8 0 104 16l2.6-1.1A5.2 5.2 0 1116 10h-3.5l6.2-5.9v3z"/>',
  pause: '<rect x="6" y="4" width="4" height="16" rx="2"/><rect x="14" y="4" width="4" height="16" rx="2"/>',
  sound: '<path d="M4 10h4l5-4v12l-5-4H4v-4z"/><path d="M16 9c1.4 1.7 1.4 4.3 0 6M18.5 6.5c3 3 3 8 0 11" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>',
};

export function icon(name: IconName, className = ""): string {
  return `<svg class="ui-icon ${className}" viewBox="0 0 24 24" aria-hidden="true" focusable="false">${PATHS[name]}</svg>`;
}
